import store from '../../state/store.js';
import { context } from 'shared/setup/WhitelabelContext.jsx';
import mountWhitelabelApp from 'shared/setup/mountWhitelabelApp.jsx';

import common from 'sharedAssets/locale/nb/common.json';
import search from 'sharedAssets/locale/nb/search.json';

import SearchPage from '../../SearchPage.jsx';

mountWhitelabelApp(
    store,
    {
        lng: 'nb',
        fallbackLng: 'nb',
        resources: {
            nb: { common, search },
        },
        defaultNS: 'search',
    },
    context.finn,
    SearchPage,
    'flightSearchApp'
);

if (module.hot) {
    module.hot.accept();
}
